export enum QueryKey {
  ASSET = 'asset',
  ADDRESS = 'address',
  AUCTIONS = 'auctions',
  BALANCES = 'balances',
  BUY_AMOUNT = 'buyAmount',
  COLLECTION = 'collection',
  COLLECTION_METADATA = 'collectionMetadata',
  CREATE_INVENTORY_POSITION_QUOTE = 'createInventoryPositionQuote',
  CREATE_LIQUIDITY_POSITION_QUOTE = 'createLiquidityPositionQuote',
  CREATE_VAULT_QUOTE = 'createVaultQuote',
  DEBUG_ADDRESS = 'debugAddress',
  ETHEREUM_PRICE = 'ethereumPrice',
  INVENTORY_POOLS = 'inventoryPools',
  LIQUIDITY_POOLS = 'liquidityPools',
  MERKLE_LEAVES = 'merkleLeaves',
  POOL_ACTIVITY = 'poolActivity',
  POOL_TICKS = 'poolTicks',
  POOL_CURRENT_TICK = 'poolCurrentTick',
  POSITIONS = 'positions',
  PREMIUM_PAIDS = 'premiumPaids',
  SELL_AMOUNT = 'sellAmount',
  SNAPSHOTS = 'snapshots',
  TOKEN_ACTIVITY = 'tokenActivity',
  TOP_STAKERS = 'topStakers',
  USER_ASSETS = 'userAssets',
  USER_COLLECTIONS = 'userCollections',
  V2_POSITIONS = 'v2-positions',
  V2_VAULTS = 'v2-vaults',
  VAULT_ASSETS = 'vaultAssets',
  VAULT_COLLECTION = 'vaultCollection',
  VAULT_COLLECTIONS = 'vaultCollections',
  VAULT_SNAPSHOTS = 'vaultSnapshots',
  VAULTS = 'vaults',
  WITHDRAW_INVENTORY_QUOTE = 'withdrawInventoryQuote',
  WITHDRAW_LIQUIDITY_QUOTE = 'withdrawLiquidityQuote',
  COMPUTE_VAULT_ADDRESS = 'computeVaultAddress',
  VTOKEN_TO_ETH = 'vTokenToEth',
  GAS_PRICE = 'gasPrice',
  COLOR = 'color',
  VAULT_ICON = 'vaultIcon',
  IS_SAFE_APP = 'isSafeApp',
}
